module.exports = "/images/Finland.png?75dbfedaf13204434cb9d9307e8c3ec8";